var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCloseLockBlue = function SvgCloseLockBlue(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.206 6.21865H14.3598V5.07375C14.3598 2.86422 12.5883 1.06665 10.4108 1.06665C8.23323 1.06665 6.46174 2.86422 6.46174 5.07375V6.21865H5.61552C5.4596 6.21865 5.33344 6.34667 5.33344 6.50488V13.6604C5.33344 14.2919 5.83945 14.8053 6.46174 14.8053H14.3598C14.9821 14.8053 15.4881 14.2919 15.4881 13.6604V6.50488C15.4881 6.34667 15.3619 6.21865 15.206 6.21865ZM11.2554 12.1977C11.2642 12.2785 11.2386 12.3596 11.1851 12.4202C11.1317 12.4809 11.0551 12.5155 10.9749 12.5155H9.84663C9.76648 12.5155 9.68989 12.4809 9.63645 12.4202C9.583 12.3596 9.55738 12.2785 9.56621 12.1977L9.74416 10.574C9.4552 10.3608 9.28249 10.0234 9.28249 9.65332C9.28249 9.0219 9.7885 8.50842 10.4108 8.50842C11.0331 8.50842 11.5391 9.02187 11.5391 9.65332C11.5391 10.0234 11.3664 10.3608 11.0774 10.574L11.2554 12.1977ZM12.6674 6.21865H8.15418V5.07375C8.15418 3.81119 9.1665 2.78398 10.4108 2.78398C11.655 2.78398 12.6674 3.81119 12.6674 5.07375V6.21865Z",
    fill: "#4B97E9"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCloseLockBlue, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close_lock_blue.8cb92c5a.svg";
export { ForwardRef as ReactComponent };